import React, { useEffect, useState } from 'react'
import FormNotification from '../../../../components/SelfService/FormNotification.jsx'
import { screens, makeMFARequest } from './institutionalServiceHelper.js'

export default function InstitutionalMFA({
  screenChangeHandler,
  mfaData,
  setShowLoader,
  onCancleClick,
}) {
  const [choice, setChoice] = useState('')
  const [formErrorMessage, setFormErrorMessage] = useState('')
  const onChoiceChange = (event) => {
    setChoice(event.target.value)
  }

  const onNextClicked = async () => {
    if (!choice) {
      return
    }
    setShowLoader(true)
    try {
      const data = await makeMFARequest({
        channel: choice,
      })
      if (data.value?.channel === choice) {
        const getSeletedChannel = mfaData?.find((i) => i.id === choice)
        screenChangeHandler(screens.MFA_ANSWER_SCREEN, {
          mfaAnswerData: getSeletedChannel,
        })
      } else {
        setFormErrorMessage(data?.error?.details?.message)
      }
    } catch (error) {}
    setShowLoader(false)
  }

  useEffect(() => {
    const getSMSChannel = mfaData?.find((i) => i.channel === 'SMS')
    setChoice(getSMSChannel?.id)
  }, [])

  const _mfaData = [...mfaData].sort((a, b) =>
    b.channel.localeCompare(a.channel)
  )

  return (
    <div className="u-sizeConstrained">
      <div className="Grid">
        <div className="u-sizeFull u-lg-size1of2 u-marginBottom6gu Content">
          {formErrorMessage && (
            <FormNotification content={formErrorMessage} isHtml={true} />
          )}
          <h2 className="u-marginBottom2gu u-marginTop0">
            Help us keep your account more secure
          </h2>
          <p className="u-marginBottom6gu">Verify your identity.</p>
          <div className="Radio u-flexCol">
            {_mfaData?.map((itm) => (
              <React.Fragment key={itm.channel}>
                <input
                  onChange={onChoiceChange}
                  className="Radio-button u-marginLeft0"
                  type="radio"
                  id={itm.id}
                  value={itm.id}
                  checked={choice === itm.id}
                />
                <label
                  htmlFor={itm.id}
                  className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
                >
                  {itm.channel === 'SMS'
                    ? 'Text a code to: '
                    : 'Call me with a code at: '}{' '}
                  XXX.XXX.{itm?.route?.slice(-4)}
                </label>
              </React.Fragment>
            ))}
          </div>

          <div className="u-flex">
            <div className="u-flex u-paddingTop4gu">
              <button
                onClick={onNextClicked}
                className="Button Button--primary  Button--block u-marginRight5gu u-textNoTransform u-flex1of2"
              >
                Next
              </button>
              <button
                onClick={onCancleClick}
                className="Button Button--tertiary Button--block u-textNoTransform u-flex1of2"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
